export default "__VITE_ASSET__qmNUybzf__"